import LanguageService from "../../service/LanguageService";

let model = {};

// dữ liệu form
model.dataForm = {
  id: undefined, // optional - Mã tự sinh
  code: undefined, // required, pattern: /^[a-zA-Z_][\w\-]*$/, minLength: 1 - Mã của API
  name: undefined, // required, minLength: 1 - Tên của API
  type: undefined, // required, enum(sync, async, dynamic, file) - Loại của API
  multi_probe: true, // mặc định khi tạo api là true
  description: undefined, // optional - Mô tả về API
  parameters: [],
  config: {
    request_timeout: undefined, // optional, min: 1, max: 1440 - Số phút mà request sẽ bị coi là timeout
    max_request_per_day: undefined, // optional, min: 0 - Giới hạn số lượng request (của cả hệ thống) trong một ngày
    max_request_per_user_day: undefined, // optional, min: 0 - Giới hạn số lượng request (của người dùng) trong một ngày
    probe_picker_type: undefined, // optional, enum(automatic, probe_column) - Cách lấy về probe
    probe_column: undefined, // optional - Trường dữ liệu của lấy về probe (khi probe_picker_type=probe_column). Xem trong api probe_column_config.code
  },
};
model.typeAPI = [
  { value: "sync", label: LanguageService?.lang?.t_sync_api ?? "Sync" },
  { value: "async", label: LanguageService?.lang?.t_async_api ?? "Async" },
  {
    value: "dynamic",
    label: LanguageService?.lang?.t_dynamic_api ?? "Dynamic",
  },
  { value: "file", label: LanguageService?.lang?.t_file_api ?? "Export File" },
];
model.tableRules = {
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 20,
  offset: 0,
  sort: "code",
  defaultSort: ["code", "ascending"],
  fields: "id, code, name, type, multi_probe, description, parameters, config",
  filters: "",
  dataSearch: {
    value: {
      code: "",
      type: "",
      name: "",
      multi_probe: "",
    },
    operator: {
      code: ":regex_i:",
      name: ":regex_i:",
      type: "",
      multi_probe: "",
    },
  },
};

export default model;
